/* =================================================================
   Billyhops PDP — Bench Tower-01
   Scoped interaction JS. NO cart/drawer logic.
   - Impact's <product-form> handles AJAX add-to-cart
   - theme.liquid's ensureAddOnsPresent() auto-adds the 2 accessories
   - Rebuy Smart Cart auto-opens on cart.change
   ================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('.bh-pdp');
  if (!root) return;

  /* ── Measure Impact's header height and set --bh-header-offset ──
     This makes our sticky buybox sit directly below the real header
     rather than assuming a hardcoded 72px. Re-measures on resize. */
  (function () {
    function measureHeader() {
      // Impact uses <store-header> custom element. Fall back to common selectors.
      var header = document.querySelector('store-header')
                || document.querySelector('.shopify-section-group-header-group')
                || document.querySelector('header[role="banner"]')
                || document.querySelector('.header');
      if (!header) return;
      var rect = header.getBoundingClientRect();
      // Only use the measured height if the header is actually sticky/fixed.
      // Otherwise a top: 0 sticky buybox is correct.
      var cs = getComputedStyle(header);
      var isFixed = cs.position === 'fixed' || cs.position === 'sticky';
      var offset = isFixed ? Math.round(rect.height) : 0;
      root.style.setProperty('--bh-header-offset', offset + 'px');
    }
    measureHeader();
    // Re-measure on resize + after fonts load (header can reflow).
    window.addEventListener('resize', measureHeader);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureHeader);
    }
    // One more pass on full load in case lazy-loaded header sections change height.
    window.addEventListener('load', measureHeader);
  })();

  /* ── Mobile image carousel: swipe + tap thumbnails ── */
  (function () {
    var carousel = root.querySelector('#mCarousel');
    var track = root.querySelector('#mImgTrack');
    var dotsWrap = root.querySelector('#mImgDots');
    var thumbsWrap = root.querySelector('#mThumbs');
    if (!carousel || !track) return;

    var slides = track.querySelectorAll('.m-img-slide');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.m-img-dot') : [];
    var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('.m-thumb') : [];
    var total = slides.length;
    var current = 0;
    var touchStartX = 0, touchStartY = 0, dragging = false;

    function goTo(idx) {
      idx = Math.max(0, Math.min(idx, total - 1));
      current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('active', i === idx);
      for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('active', j === idx);
      if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    for (var i = 0; i < dots.length; i++) {
      (function (d, idx) { d.addEventListener('click', function () { goTo(idx); }); })(dots[i], i);
    }
    for (var k = 0; k < thumbs.length; k++) {
      (function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); })(thumbs[k], k);
    }

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragging = false;
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (!dragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) dragging = true;
      if (dragging) e.preventDefault();
    }, { passive: false });

    carousel.addEventListener('touchend', function (e) {
      if (!dragging) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
      dragging = false;
    }, { passive: true });
  })();

  /* ── Bench Tower in Action: horizontal drag ── */
  (function () {
    var btaTrack = root.querySelector('#btaTrack');
    if (!btaTrack) return;
    var dragging = false, startX, scrollLeft;
    btaTrack.addEventListener('mousedown', function (e) {
      dragging = true; btaTrack.classList.add('dragging');
      startX = e.pageX - btaTrack.offsetLeft;
      scrollLeft = btaTrack.scrollLeft;
    });
    btaTrack.addEventListener('mouseleave', function () { dragging = false; btaTrack.classList.remove('dragging'); });
    btaTrack.addEventListener('mouseup', function () { dragging = false; btaTrack.classList.remove('dragging'); });
    btaTrack.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      btaTrack.scrollLeft = scrollLeft - (e.pageX - btaTrack.offsetLeft - startX) * 1.5;
    });
  })();

  /* ── Feature strip mobile carousel dots ──
     v23 scroll-stutter fix: rAF-throttled + skip redundant writes. */
  (function () {
    var featCarousel = root.querySelector('#featCarousel');
    var featDots = root.querySelectorAll('.feat-dot');
    if (!featCarousel || !featDots.length) return;

    var ticking = false;
    var lastActive = -1;

    featCarousel.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(featCarousel.scrollLeft / featCarousel.offsetWidth);
        if (i !== lastActive) {
          lastActive = i;
          featDots.forEach(function (d, j) { d.classList.toggle('active', i === j); });
        }
        ticking = false;
      });
    }, { passive: true });

    featDots.forEach(function (d) {
      d.addEventListener('click', function () {
        featCarousel.scrollTo({ left: parseInt(d.dataset.i, 10) * featCarousel.offsetWidth, behavior: 'smooth' });
      });
    });
  })();

  /* ── Accordion: Limited release details ── */
  root.querySelectorAll('.acc-trigger').forEach(function (btn) {
    /* skip triggers inside the presale modal - it has its own handler */
    if (btn.closest('.bh-modal')) return;
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      var beforeY = btn.getBoundingClientRect().top;
      root.querySelectorAll('.acc-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
      var afterY = btn.getBoundingClientRect().top;
      window.scrollBy({ top: afterY - beforeY, behavior: 'instant' });
    });
  });

  /* ── Accordion: FAQ ──
     NOTE: FAQ lives in a separate section (its own .bh-pdp wrapper).
     Use document.querySelectorAll, not root.querySelectorAll. */
  document.querySelectorAll('.faq-acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      var beforeY = btn.getBoundingClientRect().top;
      document.querySelectorAll('.faq-acc-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
      var afterY = btn.getBoundingClientRect().top;
      window.scrollBy({ top: afterY - beforeY, behavior: 'instant' });
    });
  });

  /* ── Sticky CTA: show after scroll, when main ATC form out of view ──
     NOTE: Sticky CTA lives in the FAQ section (separate .bh-pdp wrapper
     from the main buybox). Use document.querySelector, not root.querySelector.
     v23 scroll-stutter fix:
       - Cache atcTop (don't call getBoundingClientRect every scroll frame)
       - Throttle with requestAnimationFrame (1 read per frame max)
       - Only toggle class when state actually changes (avoid redundant DOM writes)
     Previously this handler fired ~60x/sec during scroll, each call forcing a
     layout read via getBoundingClientRect on scroll-up. On iOS Safari that
     compounds with URL-bar resize reflow and causes the visible scroll snap. */
  (function () {
    var stickyCta = document.querySelector('#stickyCta');
    var atcDesktop = document.querySelector('#staticCtaDesktop');
    var atcMobile = document.querySelector('#staticCtaMobile');
    if (!stickyCta) return;

    var hasScrolled = false;
    var atcTopDesktop = 0;
    var atcTopMobile = 0;
    var ticking = false;
    var lastVisible = false;

    function measureAtcTops() {
      if (atcDesktop) {
        atcTopDesktop = atcDesktop.getBoundingClientRect().top + window.scrollY;
      }
      if (atcMobile) {
        atcTopMobile = atcMobile.getBoundingClientRect().top + window.scrollY;
      }
    }

    // Initial measure + re-measure only on resize / load (not on every scroll)
    measureAtcTops();
    window.addEventListener('resize', measureAtcTops);
    window.addEventListener('load', measureAtcTops);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureAtcTops);
    }

    function setVisible(v) {
      if (v === lastVisible) return; // skip redundant DOM writes
      lastVisible = v;
      if (v) stickyCta.classList.add('visible');
      else stickyCta.classList.remove('visible');
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!hasScrolled) return;
      entries.forEach(function (entry) {
        var isMobile = window.innerWidth <= 900;
        var isRelevant = isMobile ? entry.target === atcMobile : entry.target === atcDesktop;
        if (!isRelevant) return;
        setVisible(!entry.isIntersecting);
      });
    }, { threshold: 0 });

    if (atcDesktop) observer.observe(atcDesktop);
    if (atcMobile) observer.observe(atcMobile);

    window.addEventListener('scroll', function () { hasScrolled = true; }, { passive: true, once: true });

    // rAF-throttled above-ATC check. No layout reads inside the handler.
    window.addEventListener('scroll', function () {
      if (!hasScrolled || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var isMobile = window.innerWidth <= 900;
        var atcTop = isMobile ? atcTopMobile : atcTopDesktop;
        if (atcTop && window.scrollY < atcTop) {
          setVisible(false);
        }
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ── Sticky CTA button: submit the main product-form when clicked ── */
  (function () {
    var stickyBtn = document.querySelector('.sticky-cta-btn');
    if (!stickyBtn) return;
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Form lives in the main section — search whole document
      var form = document.querySelector('.bh-product-form form, form.bh-product-form, [is="product-form"]');
      if (!form) return;
      var submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
      if (submitBtn) { submitBtn.click(); }
      else { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  })();
})();

/* ── v15 Lazy autoplay videos — only load + play when scrolled into view ── */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var videos = document.querySelectorAll('video[autoplay]');
  if (!videos.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
        v.play().catch(function(){});
      } else {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0 });
  videos.forEach(function (v) { io.observe(v); });
})();


/* ── Presale & shipping terms modal (US PDP) ──
   Standalone top-level block (same pattern as the lazy-video IIFE above).
   The modal markup lives inside .bh-pdp but we query by id, so this works
   regardless of wrapper scope. Modal accordions use a LOCAL toggle that does
   NOT call window.scrollBy (that would move the scroll-locked background). */
(function () {
  'use strict';
  var modal    = document.getElementById('bhPresaleModal');
  var backdrop = document.getElementById('bhPresaleBackdrop');
  if (!modal || !backdrop) return;

  var lastFocus = null;

  var savedScrollY = 0;
  function lockScroll(on) {
    if (on) {
      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.classList.add('bh-modal-open');
    } else {
      document.body.classList.remove('bh-modal-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }
  }

  window.bhOpenPresaleModal = function (trigger) {
    lastFocus = trigger || document.activeElement;
    backdrop.classList.add('open');
    modal.classList.add('open');
    lockScroll(true);
    var c = modal.querySelector('.bh-modal-close');
    if (c) c.focus();
  };

  window.bhClosePresaleModal = function () {
    backdrop.classList.remove('open');
    modal.classList.remove('open');
    lockScroll(false);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  /* Esc closes */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) {
      window.bhClosePresaleModal();
    }
  });

  /* simple focus trap within the modal */
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* modal-scoped accordion toggle (no window.scrollBy) */
  var modalBody = modal.querySelector('.bh-modal-body');
  modal.querySelectorAll('.acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      var beforeY = btn.getBoundingClientRect().top;
      modal.querySelectorAll('.acc-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
      var afterY = btn.getBoundingClientRect().top;
      if (modalBody) modalBody.scrollTop += (afterY - beforeY);
    });
  });
})();
